import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { StateService } from '@/core/services/state.service';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { SectionService } from '@/core/services/section.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { I18nService } from '@/core/services/i18nService';
import { ConfirmationDialogResult, ConfirmationDialogAction, ConfirmationDialogComponent } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { StammdatenService } from '@/core/services/stammdaten.service';
import * as confetti from 'canvas-confetti';
import { Constants } from '@/constants';
import { DataprotectionNotificationDisplayModelFormGroup } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/dataprotection-notification-display-model';
import { BaseNavigationFormComponent } from '@/core/components/base-navigation-form/base-navigation-form.component';
import { MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { AnfrageService, GutachtenService } from '@/api/service-index';
import { FormGroup } from '@angular/forms';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { Subscription } from 'rxjs';
import { ExtendedDialogService } from '@/core/services/extended-dialog.service';


@Component({
  selector: 'dataprotection-process-step',
  templateUrl: 'dataprotection-process-step.component.html',
  styleUrls: ['dataprotection-process-step.component.scss'],
})

export class DataprotectionProcessStepComponent extends BaseNavigationFormComponent implements AfterViewInit {

  protected successDialog: DialogRef;
  protected submitDialog: DialogRef;
  public dataprotectionProcessStepForm: DataprotectionNotificationDisplayModelFormGroup;

  public portalkonfiguration: PortalkonfigurationDisplayModel;

  public get isDataprotectionNotificationVisible(): boolean {
    return !this.isValidationViewVisible || this.dataprotectionProcessStepForm.disabled;
  }

  public get isValidationViewVisible(): boolean {
    var hasErrors = false;

    if (this.stateService.ValidationErrors) {
      Object.values(this.stateService.ValidationErrors).forEach((errors) => {
        if (errors.length > 0) {
          hasErrors = true;
        }
      });
    }

    return hasErrors;
  }

  public get isSubmitDisabled(): boolean {
    return (this.dataprotectionProcessStepForm.DsgvoAccepted.value != true) || this.dataprotectionProcessStepForm.disabled;
  }

  public get formGroup(): FormGroup<any> {
    return this.dataprotectionProcessStepForm;
  }

  constructor(
    protected sectionService: SectionService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected portalContextService: PortalContextService,
    protected stateService: StateService,
    protected dialogService: ExtendedDialogService,
    protected languageService: I18nService,
    protected stammdatenService: StammdatenService,
    protected anfrageService: AnfrageService,
    protected gutachtenService: GutachtenService,
    protected loadingAnimationService: LoadingAnimationService) {

    super(sectionService, router, route, portalContextService);
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
    this.stateService.ValidationErrors = this.route.snapshot.data.errors;

    this.dataprotectionProcessStepForm = DataprotectionNotificationDisplayModelFormGroup.Instance;
  }

  ngAfterViewInit(): void {
    this.dataprotectionProcessStepForm.markAllAsTouched();
  }

  protected openSuccessDialog(): void {
    this.successDialog = this.dialogService.open({
      content: ConfirmationDialogComponent,
      maxWidth: Constants.DIALOG.MAX_WIDTH,
      maxHeight: Constants.DIALOG.MAX_WIDTH,
      width: Constants.DIALOG.WIDTH,
      title: this.languageService.instant("successfully_sent"),
    }, false);

    let dialogComponent: ConfirmationDialogComponent = this.successDialog.content.instance;
    dialogComponent.content = this.languageService.getCurrentLocalizedTextDisplayModel(this.stammdatenService.Portalkonfiguration.erfolgreichAbgesendetTexte)?.text ?? this.languageService.instant("successfully_sent");
    dialogComponent.confirm = "conformationDialog.confirm";
    dialogComponent.showCancel = false;

    // Zeichne Wrapper für Canvas Positionierung
    var myDiv = document.createElement('div');
    myDiv.style.display = 'flex';
    myDiv.style.justifyContent = 'center';
    myDiv.style.alignItems = 'flex-end';
    myDiv.style.position = 'absolute';
    myDiv.style.width = '100%';
    myDiv.style.height = '100%';
    myDiv.style.zIndex = '99999';
    myDiv.style.pointerEvents = 'none';

    // Zeichne Canvas für Konfetti
    var myCanvas = document.createElement('canvas');
    myCanvas.style.display = 'flex';
    myCanvas.style.justifyContent = 'center';
    myCanvas.style.alignItems = 'flex-end';
    myCanvas.style.position = 'absolute';
    myCanvas.style.width = '100%';
    myCanvas.style.height = '100%';
    myCanvas.style.pointerEvents = 'none';

    // Füge Canvas in Wrapper ein
    myDiv.appendChild(myCanvas);

    document.body.prepend(myDiv);

    // particleCount: Anzahl der Konfetti
    // spread: Streuung
    confetti.create(myCanvas, {
      resize: true,
      useWorker: true
    })({
      particleCount: 200,
      spread: 160,
      zIndex: 99999,
    });
  }

  protected onSubmitProjektDialogClose(result: ConfirmationDialogResult) {
    if (result.action == ConfirmationDialogAction.Confirm)
      this.submit();
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    // Nothing to do in that form
    this.move(moveDirection);
  }

  protected validationOnLanguageChangeFunction() {
    const id: string = this.portalContextService.CurrentItemContext?.id;
    if (id) {
      this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.portalContextService.CurrentAnfrage?.id, reportId: this.portalContextService.CurrentBericht?.projektberichtId, gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId! }).subscribe(result => {
       this.stateService.ValidationErrors = result;
      });
    }
  }

  protected openSubmitDialog(titleKey : string){
    this.submitDialog = this.dialogService.open({
      content: ConfirmationDialogComponent,
      maxWidth: Constants.DIALOG.MAX_WIDTH,
      maxHeight: Constants.DIALOG.MAX_HEIGHT,
      width: Constants.DIALOG.WIDTH,
      title: this.languageService.instant(titleKey),
    });

    let dialogComponent: ConfirmationDialogComponent = this.submitDialog.content.instance;

    const text = this.languageService.getCurrentLocalizedTextDisplayModel(this.portalContextService.currentPhase?.bestaetigunstextVorAbsenden)?.text;

    if (text) {
      dialogComponent.content = text;
    } else {
      dialogComponent.content = this.languageService.getCurrentLocalizedTextDisplayModel(this.stammdatenService.Portalkonfiguration.bestaetigunstextVorAbsenden)?.text ?? "";
    }

    dialogComponent.confirm = "submitdialogue.submit_send";

    this.submitDialog.result.subscribe(result => this.onSubmitProjektDialogClose(<ConfirmationDialogResult>result));
  
  }

  protected submit(): void{
    let subscription : Subscription | undefined ;
    if (this.portalContextService.CurrentGutachten?.gutachtenId)
    {
      subscription = this.gutachtenService.apiGutachtenSubmitGutachtePatch({ gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId! })
      .subscribe(() => {
        this.dataprotectionProcessStepForm.markAsPristine();
        this.stateService.clearCache();
        //this.openSuccessDialog(); OpenSuccessDialog on review?
        this.router.navigate(['../../../../', 'overview'], { relativeTo: this.route });
      });
    }
    else if(this.portalContextService.CurrentBericht?.projektberichtId && this.portalContextService.CurrentAnfrage.id)
    {
      subscription = this.anfrageService.apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost({ anfrageId: this.portalContextService.CurrentAnfrage.id, berichtId: this.portalContextService.CurrentBericht?.projektberichtId })
      .subscribe(() => {
        this.dataprotectionProcessStepForm.markAsPristine();
        this.stateService.clearCache();
        this.openSuccessDialog();
        this.router.navigate(['../../../../../', 'overview'], { relativeTo: this.route });
      });
    }
    else if(this.portalContextService.CurrentAnfrage.id)
    {
      subscription = this.anfrageService.apiAnfrageAnfrageIdSubmitPost({ anfrageId: this.portalContextService.CurrentAnfrage.id, body: this.dataprotectionProcessStepForm.value })
      .subscribe(() => {
        this.dataprotectionProcessStepForm.markAsPristine();
        this.stateService.clearCache();
        this.openSuccessDialog();
        this.router.navigate(['../../../../', 'overview'], { relativeTo: this.route });
      });
    }

    if(subscription)
      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  protected onSubmitClick(): void{
    if(this.portalContextService.CurrentGutachten?.gutachtenId){
      this.openSubmitDialog("review.submitdialogue.title");
    }
    else if(this.portalContextService.CurrentBericht?.projektberichtId){
      this.openSubmitDialog("submitdialogue.report.title");
    }
    else{
      this.openSubmitDialog("submitdialogue.title")

    }
  }
}
